export const triggerBlur = (name: string) => {
  const el = document.querySelector(`input[name="${name}"]`);
  if (el) el.dispatchEvent(new FocusEvent('blur', { bubbles: true }));
};
